export enum WallPositionKey {
  EndWall = 'end-wall-position',
  SideWall = 'side-wall-position',
}
